import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useUser } from './context/UserContext';
import { useAccess } from './hooks/useAccess';

export default function PrivateRoutes() {
  const { isAuthenticated, isReady, role } = useUser();
  const location = useLocation();
  const navigate = useNavigate();
  const { canAccess } = useAccess();

  // Role-based route redirects
  useEffect(() => {
    if (!role) return;
    if (role === 'super-admin' && location.pathname === '/dashboard') {
      navigate('/admin/dashboard', { replace: true });
    }
  }, [location.pathname, role, navigate]);

  if (!isReady) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace={true} state={{ from: location }} />;

  const routePoliciesMap = {
    '/users': 'ManageTeam',
    '/admin/dashboard': 'ViewReports',
    '/admin/roles-permissions': 'ManageRolesAndPermissions',
    '/settings': 'ManageOrgSettings',
  };

  const requiredPolicy = routePoliciesMap[location.pathname];
  if (requiredPolicy && !canAccess(requiredPolicy)) {
    return <Navigate to="/unauthorized" replace={true} />;
  }

  return <Outlet />;
}